import { render, staticRenderFns } from "./class-calendar-merge.vue?vue&type=template&id=7334bec3&"
import script from "./class-calendar-merge.vue?vue&type=script&lang=js&"
export * from "./class-calendar-merge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports